/* @flow */
import {
  removeBlockActionMaker,
  cropableImageModalActionMaker
} from '@website/components/ActionMakers'
import {
  addBlock,
  changeTitle,
  changeParagraph,
  changeTitleAlignment,
  changeParagraphAlignment
} from '@website/components/CommonActions'
export default dispatcher => {
  const changeBlockTitle = (title: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_TITLE',
      value: { title, idx }
    })
  }

  const changeBlockContent = (content: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_CONTENT',
      value: { content, idx }
    })
  }

  const changeBlockTitleAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_TITLE_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  const changeBlockParagraphAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_PARAGRAPH_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  const _changeTitle = (title: string) => {
    dispatcher(changeTitle(title))
  }

  const _changeParagraph = (paragraph: string) => {
    dispatcher(changeParagraph(paragraph))
  }

  const _changeTitleAlignment = alignment => {
    dispatcher(changeTitleAlignment(alignment))
  }

  const _changeParagraphAlignment = alignment => {
    dispatcher(changeParagraphAlignment(alignment))
  }

  const _addBlock = () => {
    dispatcher(addBlock())
  }

  return {
    addBlock: _addBlock,
    changeTitle: _changeTitle,
    changeParagraph: _changeParagraph,
    changeTitleAlignment: _changeTitleAlignment,
    changeParagraphAlignment: _changeParagraphAlignment,
    changeBlockTitle,
    changeBlockContent,
    changeBlockTitleAlignment,
    changeBlockParagraphAlignment,
    imageActions: (idx, imageUrl) =>
      cropableImageModalActionMaker(dispatcher)({
        keyForSizes: 'steps2',
        showRemove: false,
        additionalArgs: { idx },
        imageUrl
      }),
    stepActions: removeBlockActionMaker(dispatcher)
  }
}
